module.exports = {"tag":"v0.1.9"}


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = 399
// module chunks = 1